import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {ObjectDetailTitle} from '../../search-list/results/result-item/object-detail-title.model';
import {ActivatedRoute} from "@angular/router";
import {ObjectLink} from "./object-link.model";
import {AppConfigService} from "../../../config/app-config.service";

@Component({
  selector: 'app-object-title',
  templateUrl: './object-title.component.html',
  styleUrls: ['./object-title.component.scss']
})
export class ObjectTitleComponent implements OnChanges {

  @Input() mobile = false;

  @Input() objectDetailTitle: ObjectDetailTitle = new ObjectDetailTitle({authors: [], title:new ObjectLink({}), extras:[]});

  showAll = false;

  constructor(private route: ActivatedRoute, public appConfig: AppConfigService) {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.objectDetailTitle) {
      let sort = this.route.snapshot.queryParamMap.get('sort');
      let authors = [];
      if (sort && sort.lastIndexOf('work_main_creator.value.value') >= 0) {
        if (sort.lastIndexOf('asc') >= 0) {
          authors = this.sortAlphabetically(this.objectDetailTitle);
        } else {
          authors = this.sortAlphabetically(this.objectDetailTitle).reverse();
        }
      } else {
        authors = this.sortAlphabetically(this.objectDetailTitle);
      }
      this.objectDetailTitle.authors = authors;
    }
  }

  getFirstAuthors(): ObjectLink[] {
    return this.objectDetailTitle.authors.slice(0,this.appConfig.showMoreConfig.maxAuthors);
  }

  private sortAlphabetically(value: ObjectDetailTitle) {
    return value.authors.sort((a, b) => a.label.localeCompare(b.label));
  }
}
